import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListeDocumentsComponent } from './liste-documents/liste-documents.component';
import { HistoriqueComponent } from './historique/historique.component';
import { CoordonneesProspectComponent } from './coordonnees-prospect/coordonnees-prospect.component';
import { InformationsTicketComponent } from './informations-ticket/informations-ticket.component';
import { CommentairesClientTicketComponent } from './commentaires-client-ticket/commentaires-client-ticket.component';
import { SharedModule } from '../../../shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
import { TicketInformationsSpecifiqueComponent } from './ticket-informations-specifique/ticket-informations-specifique.component';
import { AngularEditorModule } from '../../../components/angular-editor/angular-editor.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GarantieComponent } from './garantie/garantie.component';
import { SousTicketComponent } from './sous-ticket/sous-ticket.component';
import { TransactionFinanciereComponent } from './transaction-financiere/transaction-financiere.component';
import { FraisComponent } from './frais/frais.component';
@NgModule({
  declarations: [
    ListeDocumentsComponent,
    HistoriqueComponent,
    CoordonneesProspectComponent,
    InformationsTicketComponent,
    CommentairesClientTicketComponent,
    TicketInformationsSpecifiqueComponent,
    GarantieComponent,
    SousTicketComponent,
    TransactionFinanciereComponent,
    FraisComponent,
  ],
  imports: [CommonModule, SharedModule, MatMenuModule, AngularEditorModule,TranslateModule],
  exports: [
    ListeDocumentsComponent,
    HistoriqueComponent,
    CoordonneesProspectComponent,
    InformationsTicketComponent,
    CommentairesClientTicketComponent,
    TicketInformationsSpecifiqueComponent,
    GarantieComponent,
    SousTicketComponent,
    TransactionFinanciereComponent,
    FraisComponent,
    TranslateModule
  ],
})
export class TicketsDetailsModule implements OnInit {
  ngOnInit(): void {}
}
